// import axios, { AxiosHeaders, InternalAxiosRequestConfig } from "axios";
// import { config } from "@/config";
// import { useAuthStore } from "@/store/auth";
// import { convertToCamelCase, convertToSnakeCase } from "./case-converter";

// const API_BASE_URL = config.apiBaseUrl;

// export const apiClient = axios.create({
//   baseURL: config.mockMode ? "/api" : API_BASE_URL,
//   timeout: 30000,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// let refreshTokenPromise: Promise<any> | null = null;

// apiClient.interceptors.request.use(
//   async (axiosConfig: InternalAxiosRequestConfig) => {
//     // refresh token endpoint removed from this block so as to prevent infinite loops
//     if (axiosConfig.url === "/v1/admin/refresh") {
//       if (axiosConfig.data)
//         axiosConfig.data = convertToSnakeCase(axiosConfig.data);
//       if (axiosConfig.params)
//         axiosConfig.params = convertToSnakeCase(axiosConfig.params);
//       return axiosConfig;
//     }

//     const { token, expiresAt, login } = useAuthStore.getState();
//     const tokenRefreshThreshold = 5 * 60 * 1000; // 5 minutes before expiry

//     if (token && expiresAt && expiresAt - Date.now() < tokenRefreshThreshold) {
//       if (!refreshTokenPromise) {
//         refreshTokenPromise = apiClient
//           .post("/v1/admin/refresh")
//           .then((response) => {
//             const { token: accessToken, expiresIn } = response.data;
//             const user = useAuthStore.getState().user;
//             if (user) {
//               login(user, accessToken, expiresIn);
//             }
//             return accessToken;
//           })
//           .catch((error) => {
//             useAuthStore.getState().logout();
//             return Promise.reject(error);
//           })
//           .finally(() => {
//             refreshTokenPromise = null;
//           });
//       }

//       const newToken = await refreshTokenPromise;
//       if (newToken) {
//         if (!axiosConfig.headers) {
//           axiosConfig.headers = new AxiosHeaders();
//         }
//         axiosConfig.headers.Authorization = `Bearer ${newToken}`;
//       }
//     } else if (token) {
//       if (!axiosConfig.headers) {
//         axiosConfig.headers = new AxiosHeaders();
//       }
//       axiosConfig.headers.Authorization = `Bearer ${token}`;
//     }

//     if (axiosConfig.data)
//       axiosConfig.data = convertToSnakeCase(axiosConfig.data);
//     if (axiosConfig.params)
//       axiosConfig.params = convertToSnakeCase(axiosConfig.params);

//     return axiosConfig;
//   },
//   (error) => Promise.reject(error)
// );

// // response interceptor to convert response data to camelCase
// apiClient.interceptors.response.use(
//   (response) => {
//     const contentType = response.headers["content-type"];

//     // Only attempt to convert case for JSON responses.
//     // This prevents corruption of non-JSON data like file blobs.
//     if (
//       response.data &&
//       contentType &&
//       contentType.includes("application/json")
//     ) {
//       response.data = convertToCamelCase(response.data);
//     }
//     return response;
//   },
//   (error) => {
//     const contentType = error.response?.headers["content-type"];
//     if (
//       error.response?.data &&
//       contentType &&
//       contentType.includes("application/json")
//     ) {
//       error.response.data = convertToCamelCase(error.response.data);
//     }
//     const originalRequest = error.config;
//     if (
//       error.response?.status === 401 &&
//       !originalRequest._retry &&
//       !originalRequest.url?.includes("/two-factor/verify-otp") &&
//       !originalRequest.url?.includes("/login")
//     ) {
//       originalRequest._retry = true;
//       const { logout } = useAuthStore.getState();
//       logout();
//       window.location.href = "/login";
//     }
//     return Promise.reject(error);
//   }
// );

// import axios, { AxiosError } from "axios";
// import { config } from "@/config";
// import { useAuthStore } from "@/store/auth";
// import { convertToCamelCase, convertToSnakeCase } from "./case-converter";

// const API_BASE_URL = config.apiBaseUrl;

// export const apiClient = axios.create({
//   baseURL: config.mockMode ? "/api" : API_BASE_URL,
//   timeout: 30000,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

// let refreshTokenPromise: Promise<any> | null = null;

// apiClient.interceptors.request.use(
//   (config) => {
//     if (config.data) {
//       config.data = convertToSnakeCase(config.data);
//     }
//     if (config.params) {
//       config.params = convertToSnakeCase(config.params);
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// apiClient.interceptors.response.use(
//   (response) => {
//     if (response.data) {
//       response.data = convertToCamelCase(response.data);
//     }
//     return response;
//   },
//   async (error: AxiosError) => {
//     const originalRequest = error.config;

//     if (error.response?.data) {
//       error.response.data = convertToCamelCase(error.response.data);
//     }

//     // Check if the error is a 401, it's not a retry, and the endpoint is not the refresh endpoint itself
//     if (
//       error.response?.status === 401 &&
//       originalRequest &&
//       !originalRequest._retry &&
//       originalRequest.url !== "/v1/admin/refresh"
//     ) {
//       originalRequest._retry = true;

//       if (!refreshTokenPromise) {
//         refreshTokenPromise = apiClient
//           .post("/v1/admin/refresh")
//           .finally(() => {
//             refreshTokenPromise = null;
//           });
//       }

//       try {
//         await refreshTokenPromise;
//         return apiClient(originalRequest);
//       } catch (refreshError) {
//         const { logout } = useAuthStore.getState();
//         logout();
//         window.location.href = "/login";
//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// import axios, { AxiosError } from "axios";
// import { config } from "@/config";
// import { useAuthStore } from "@/store/auth";
// import { convertToCamelCase, convertToSnakeCase } from "./case-converter";

// const API_BASE_URL = config.apiBaseUrl;

// export const apiClient = axios.create({
//   baseURL: config.mockMode ? "/api" : API_BASE_URL,
//   timeout: 30000,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

// let refreshTokenPromise: Promise<any> | null = null;

// apiClient.interceptors.request.use(
//   (config) => {
//     // Do not send cookies for login or logout endpoints
//     // if (config.url === "/v1/admin/login" || config.url === "/v1/admin/logout") {
//     //   config.withCredentials = false;
//     // }

//     // refresh token endpoint removed from this block so as to prevent infinite loops
//     if (config.url === "/v1/admin/refresh") {
//       if (config.data) config.data = convertToSnakeCase(config.data);
//       if (config.params) config.params = convertToSnakeCase(config.params);
//       return config;
//     }

//     if (config.data) {
//       config.data = convertToSnakeCase(config.data);
//     }
//     if (config.params) {
//       config.params = convertToSnakeCase(config.params);
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// apiClient.interceptors.response.use(
//   (response) => {
//     const contentType = response.headers["content-type"];

//     // Only attempt to convert case for JSON responses.
//     // This prevents corruption of non-JSON data like file blobs.
//     if (
//       response.data &&
//       contentType &&
//       contentType.includes("application/json")
//     ) {
//       response.data = convertToCamelCase(response.data);
//     }
//     return response;
//   },
//   async (error: AxiosError) => {
//     const contentType = error.response?.headers["content-type"];
//     if (
//       error.response?.data &&
//       contentType &&
//       contentType.includes("application/json")
//     ) {
//       error.response.data = convertToCamelCase(error.response.data);
//     }

//     const originalRequest = error.config;

//     // Check if the error is a 401, it's not a retry, and the endpoint is not the refresh endpoint itself
//     if (
//       error.response?.status === 401 &&
//       originalRequest &&
//       !originalRequest._retry &&
//       originalRequest.url !== "/v1/admin/refresh" &&
//       !originalRequest.url?.includes("/two-factor/verify-otp") &&
//       !originalRequest.url?.includes("/login")
//     ) {
//       originalRequest._retry = true;

//       if (!refreshTokenPromise) {
//         refreshTokenPromise = apiClient
//           .post("/v1/admin/refresh")
//           .finally(() => {
//             refreshTokenPromise = null;
//           });
//       }

//       try {
//         await refreshTokenPromise;
//         return apiClient(originalRequest);
//       } catch (refreshError) {
//         const { logout } = useAuthStore.getState();
//         logout();
//         window.location.href = "/login";
//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// import axios, { AxiosError } from "axios";
// import { config } from "@/config";
// import { useAuthStore } from "@/store/auth";
// import { convertToCamelCase, convertToSnakeCase } from "./case-converter";

// const API_BASE_URL = config.apiBaseUrl;

// export const apiClient = axios.create({
//   baseURL: config.mockMode ? "/api" : API_BASE_URL,
//   timeout: 30000,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

// let refreshTokenPromise: Promise<any> | null = null;

// const unauthenticatedEndpoints = [
//   "/v1/admin/login",
//   "/v1/admin/logout",
//   "/v1/admin/refresh",
// ];

// const isUnauthenticatedEndpoint = (url: string | undefined): boolean => {
//   if (!url) return false;
//   return (
//     unauthenticatedEndpoints.some((endpoint) => url.includes(endpoint)) ||
//     url.includes("/two-factor/verify-otp")
//   );
// };

// const refreshToken = async (): Promise<void> => {
//   if (!refreshTokenPromise) {
//     refreshTokenPromise = apiClient.post("/v1/admin/refresh").finally(() => {
//       refreshTokenPromise = null;
//     });
//   }
//   await refreshTokenPromise;
// };

// apiClient.interceptors.request.use(
//   async (config) => {
//     if (config.url === "/v1/admin/refresh") {
//       if (config.data) config.data = convertToSnakeCase(config.data);
//       if (config.params) config.params = convertToSnakeCase(config.params);
//       return config;
//     }

//     if (!isUnauthenticatedEndpoint(config.url)) {
//       try {
//         await refreshToken();
//       } catch (error) {
//         const { logout } = useAuthStore.getState();
//         logout();
//         window.location.href = "/login";
//         throw error;
//       }
//     }

//     if (config.data) {
//       config.data = convertToSnakeCase(config.data);
//     }
//     if (config.params) {
//       config.params = convertToSnakeCase(config.params);
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// apiClient.interceptors.response.use(
//   (response) => {
//     const contentType = response.headers["content-type"];

//     if (
//       response.data &&
//       contentType &&
//       contentType.includes("application/json")
//     ) {
//       response.data = convertToCamelCase(response.data);
//     }
//     return response;
//   },
//   async (error: AxiosError) => {
//     const contentType = error.response?.headers["content-type"];
//     if (
//       error.response?.data &&
//       contentType &&
//       contentType.includes("application/json")
//     ) {
//       error.response.data = convertToCamelCase(error.response.data);
//     }

//     const originalRequest = error.config;

//     if (
//       error.response?.status === 401 &&
//       originalRequest &&
//       !originalRequest._retry &&
//       originalRequest.url !== "/v1/admin/refresh" &&
//       !originalRequest.url?.includes("/two-factor/verify-otp") &&
//       !originalRequest.url?.includes("/login")
//     ) {
//       originalRequest._retry = true;

//       if (!refreshTokenPromise) {
//         refreshTokenPromise = apiClient
//           .post("/v1/admin/refresh")
//           .finally(() => {
//             refreshTokenPromise = null;
//           });
//       }

//       try {
//         await refreshTokenPromise;
//         return apiClient(originalRequest);
//       } catch (refreshError) {
//         const { logout } = useAuthStore.getState();
//         logout();
//         window.location.href = "/login";
//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

import axios, { AxiosError } from "axios";
import { config } from "@/config";
import { useAuthStore } from "@/store/auth";
import { convertToCamelCase, convertToSnakeCase } from "./case-converter";
import { InternalAxiosRequestConfig } from "axios";

const API_BASE_URL = config.apiBaseUrl;

// export const apiClient = axios.create({
//   baseURL: config.mockMode ? "/api" : API_BASE_URL,
//   timeout: 30000,
//   headers: {
//     "Content-Type": "application/json",
//   },
//   withCredentials: true,
// });

let refreshTokenPromise: Promise<any> | null = null;

// const unauthenticatedEndpoints = [
//   "/v1/admin/login",
//   "/v1/admin/logout",
//   "/v1/admin/refresh",
//   "/v1/admin/password/reset-request",
//   "/v1/admin/password/reset",
//   "/v1/admin/invitations",
// ];

// const isUnauthenticatedEndpoint = (url: string | undefined): boolean => {
//   if (!url) return false;
//   return (
//     unauthenticatedEndpoints.some((endpoint) => url.includes(endpoint)) ||
//     url.includes("/two-factor/verify-otp")
//   );
// };

// const refreshToken = async (): Promise<void> => {
//   if (!refreshTokenPromise) {
//     refreshTokenPromise = apiClient.post("/v1/admin/refresh").finally(() => {
//       refreshTokenPromise = null;
//     });
//   }
//   await refreshTokenPromise;
// };

// apiClient.interceptors.request.use(
//   async (config) => {
//     if (config.url === "/v1/admin/refresh") {
//       if (config.data) config.data = convertToSnakeCase(config.data);
//       if (config.params) config.params = convertToSnakeCase(config.params);
//       return config;
//     }

//     if (!isUnauthenticatedEndpoint(config.url)) {
//       try {
//         await refreshToken();
//       } catch (error) {
//         const { logout } = useAuthStore.getState();
//         logout();
//         window.location.href = "/login";
//         throw error;
//       }
//     }

//     if (config.data) {
//       config.data = convertToSnakeCase(config.data);
//     }
//     if (config.params) {
//       config.params = convertToSnakeCase(config.params);
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// apiClient.interceptors.response.use(
//   (response) => {
//     const contentType = response.headers["content-type"];

//     if (
//       response.data &&
//       contentType &&
//       contentType.includes("application/json")
//     ) {
//       response.data = convertToCamelCase(response.data);
//     }
//     return response;
//   },
//   async (error: AxiosError) => {
//     const contentType = error.response?.headers["content-type"];
//     if (
//       error.response?.data &&
//       contentType &&
//       contentType.includes("application/json")
//     ) {
//       error.response.data = convertToCamelCase(error.response.data);
//     }

//     return Promise.reject(error);
//   }
// );

const handleTokenRefresh = async (
  requestConfig: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  const isAuthEndpoint =
    requestConfig.url?.includes("/login") ||
    requestConfig.url?.includes("/refresh") ||
    requestConfig.url?.includes("/logout") ||
    requestConfig.url?.includes("/password/reset-request") ||
    requestConfig.url?.includes("/password/reset") ||
    requestConfig.url?.includes("/invitations") ||
    requestConfig.url?.includes("/two-factor/verify-otp");

  if (isAuthEndpoint) {
    return requestConfig;
  }

  if (!refreshTokenPromise) {
    refreshTokenPromise = apiClient.post("/v1/admin/refresh").finally(() => {
      refreshTokenPromise = null;
    });
  }

  try {
    await refreshTokenPromise;
  } catch (error) {
    // If the refresh itself fails, logout immediately.
    const { logout } = useAuthStore.getState();
    logout();
    window.location.href = "/login";
    // This will cancel the original request
    return Promise.reject(new axios.Cancel("Session refresh failed."));
  }

  return requestConfig;
};

const handle401Error = (error: AxiosError) => {
  // For any 401 error that isn't handled by a specific retry logic,
  // the safest default is to terminate the session.
  // const { logout } = useAuthStore.getState();
  // logout();
  // window.location.href = "/login";
};

export const apiUploadClient = axios.create({
  baseURL: config.mockMode ? "/api" : API_BASE_URL,
  timeout: 60000, // Longer timeout for file uploads
  withCredentials: true,
});

// --- 1. PRIMARY JSON API CLIENT ---
export const apiClient = axios.create({
  baseURL: config.mockMode ? "/api" : API_BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Request interceptor for JSON payloads
apiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const authenticatedConfig = await handleTokenRefresh(config);

    if (authenticatedConfig.data) {
      authenticatedConfig.data = convertToSnakeCase(authenticatedConfig.data);
    }
    if (authenticatedConfig.params) {
      authenticatedConfig.params = convertToSnakeCase(
        authenticatedConfig.params
      );
    }
    return authenticatedConfig;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for JSON payloads
apiClient.interceptors.response.use(
  (response) => {
    if (
      response.data &&
      response.headers["content-type"]?.includes("application/json")
    ) {
      response.data = convertToCamelCase(response.data);
    }
    return response;
  },
  (error: AxiosError) => {
    if (
      error.response?.data &&
      error.response?.headers["content-type"]?.includes("application/json")
    ) {
      error.response.data = convertToCamelCase(error.response.data);
    }

    if (error.response?.status === 401) {
      handle401Error(error);
    }

    return Promise.reject(error);
  }
);

// The upload client has its own interceptors.
apiUploadClient.interceptors.request.use(handleTokenRefresh, (error) =>
  Promise.reject(error)
);

apiUploadClient.interceptors.response.use(
  (response) => {
    // The file upload success response IS JSON, so it needs camelCase conversion.
    if (
      response.data &&
      response.headers["content-type"]?.includes("application/json")
    ) {
      response.data = convertToCamelCase(response.data);
    }
    return response;
  },
  (error: AxiosError) => {
    // The file upload error response IS ALSO JSON.
    if (
      error.response?.data &&
      error.response?.headers["content-type"]?.includes("application/json")
    ) {
      error.response.data = convertToCamelCase(error.response.data);
    }

    if (error.response?.status === 401) {
      handle401Error(error);
    }

    return Promise.reject(error);
  }
);
